import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../layout/Header2'
import Footer from '../layout/footer'
import PortfolioFilter1 from '../element/portfolio-filter1'


class Portfolio1 extends Component {


    render() {
        return (
            <>
                                  <Header language={this.props.language} setLanguage={(data)=>this.props.setLanguage(data)} />



                 {/* <!--Search Popup--> */}
                {/* <div id="search-popup" className="search-popup">
                    <div className="close-search theme-btn"><span className="flaticon-cancel"></span></div>
                    <div className="popup-inner">
                        <div className="overlay-layer"></div>
                        <div className="search-form">
                            <form method="post" action="http://azim.commonsupport.com/Finandox/index.html">
                                <div className="form-group">
                                    <fieldset>
                                        <input type="search" className="form-control" name="search-input" value="" placeholder="Search Here" required />
                                        <input type="submit" value="Search Now!" className="theme-btn"/>
                                    </fieldset>
                                </div>
                            </form>
                            <br/>
                            <h3>Recent Search Keywords</h3>
                            <ul className="recent-searches">
                                <li><Link to={'/#'}>Finance</Link></li>
                                <li><Link to={'/#'}>Idea</Link></li>
                                <li><Link to={'/#'}>Service</Link></li>
                                <li><Link to={'/#'}>Growth</Link></li>
                                <li><Link to={'/#'}>Plan</Link></li>
                            </ul>
                        </div>
                        
                    </div>
                </div> */}
                
                {/* <!-- Page Banner Section --> */}
                {/* <section className="page-banner">
                    <div className="page-banner-bg" style={{ backgroundImage: "url(" + aboutbg + ")" }}></div>
                    <div className="bottom-rotten-curve alternate"></div>

                    <div className="auto-container">
                        <h1>Our Works</h1>
                        <ul className="bread-crumb clearfix">
                            <li><Link to={'/#'}>Home</Link></li>
                            <li className="active">Portfolio</li>
                        </ul>
                    </div>

                </section> */}
                {/* <!--End Banner Section --> */}


                {/* <!-- Gallery Section --> */}
                <PortfolioFilter1  language={this.props.language} setLanguage={(data)=>this.props.setLanguage(data)}/>

                {/* <!-- Sponsors Section --> */}
                

                {/* <Brand1/> */}



                <Footer language={this.props.language} setLanguage={(data)=>this.props.setLanguage(data)} />
            </>
        )
    }
}
export default Portfolio1;